import React from "react";
import Featured from "../components/Featured";

const MAROON = "#800020"; // deep blood red / maroon

const SubtitleCard = ({ label, rows = [] }) => (
  <div className="mb-8">
    <h3
      className="text-lg md:text-xl font-semibold mb-2 select-none"
      style={{ color: MAROON }}
    >
      {label}
    </h3>
    <div className="rounded-2xl overflow-hidden border" style={{ borderColor: MAROON }}>
      <div className="divide-y" style={{ borderColor: MAROON }}>
        {rows && rows.length > 0 ? (
          rows.map((r, i) => (
            <div
              key={`${label}-${i}`}
              className="grid grid-cols-3 px-4 py-2 text-sm md:text-base"
              style={{ color: MAROON }}
            >
              <span>{r?.what || ""}</span>
              <span>{r?.who || ""}</span>
              <span>{r?.where || ""}</span>
            </div>
          ))
        ) : (
          <div className="px-4 py-3 text-sm italic" style={{ color: MAROON }}>
            Add productions here…
          </div>
        )}
      </div>
    </div>
  </div>
);
 
const features = [
  {
    title: "Sapience",
    org: "Artists Repertory Theatre",
    image: "/images/show211.png",
    review: {
      quote: "https://www.portlandmercury.com/Theater/2025/03/03/47670351/theater-review-the-spectrum-according-to-sapience",
      source: "Portland Mercury",
    },
  },
  {
    title: "English",
    org: "SpeakEasy Stage Company",
    image: "/images/show210.png",
    review: {
      quote: "https://www.bostonglobe.com/2022/10/24/arts/realizing-speaking-their-truths-speakeasys-english/",
      source: "Boston Globe",
    },
  },
  {
    title: "Wish You Were Here",
    org: "Gloucester Stage Company",
    image: "/images/show208.png",
    review: {
      quote: "https://artsfuse.org/296627/theater-review-wish-you-were-here-innocence-lost/",
      source: "Arts Fuse",
    },
  },
];


const Section = ({ labels, rowsMap = {} }) => (
  <section className="w-full max-w-5xl mx-auto mb-12">
    {labels.map((label) => (
      <SubtitleCard key={label} label={label} rows={rowsMap[label]} />
    ))}
  </section>
);

const KeyBlock = () => (
  <section className="w-full max-w-5xl mx-auto mt-8">
    <h3
      className="text-xl md:text-2xl font-semibold tracking-tight mb-3 select-none"
      style={{ color: MAROON }}
    >
      KEY:
    </h3>
    <div
      className="rounded-xl p-4 border"
      style={{ borderColor: MAROON, backgroundColor: "#fff8fa" }}
    >
      <ul className="list-disc pl-6 text-sm md:text-base" style={{ color: MAROON }}>
        <li>* = upcoming</li>
        <li>^ = regional premiere</li>
        <li>+ = world premiere</li>
      </ul>
    </div>
  </section>
);

export default function RecentWorks() {
  const directingLabels = [
    "Directing",
    "Associate Directing",
    "Workshops / Readings",
    "Honors",
    "Regional Staff / Associations",
  ];

  const otherLabels = [
    "Dramaturgy",
    "Producing",
    "Visual Art Curation",
  ];

  const directingRows = {
    Directing: [
      { what: "Racecar Racecar Racecar^*", who: "Kallan Dana", where: "Artists Repertory Theatre" },
      { what: "English^", who: "Sanaz Toossi", where: "SpeakEasy Stage Company" },
      { what: "Sapience+", who: "Diana Burbano", where: "Artists Repertory Theatre" },
      { what: "La Cenerentola", who: "Rossini", where: "Portland Opera" },
      { what: "Wish You Were Here^", who: "Sanaz Toossi", where: "Gloucester Stage Company" },
      { what: "Adam’s Run+", who: "Ruby Fulton & Baynard Woods", where: "Renegade Opera" },
      { what: "The God Cluster+", who: "Ernie Lijoi", where: "Fuse Theatre Ensemble" },
      { what: "Who’s Holiday!^", who: "Matthew Lombardo", where: "Bag&Baggage Productions" },
      { what: "Queer Opera 2025", who: "Multiple/m.d. Chuck Dillard", where: "Queer Opera" },
    ],
    "Associate Directing": [
      { what: "Young Americans+", who: "Lauren Yee/dir. Desdemona Chiang", where: "Portland Center Stage/ Pittsburgh Public Theater" },
      { what: "American Fast+", who: "Kareem Fahmy/dir. Chip Miller", where: "Artists Repertory Theatre" },
      { what: "A Mirror^*", who: "Sam Holcroft/dir. Isaac Lamb", where: "Third Rail Repertory Theatre" },
      { what: "The Music Man", who: "Meredith Wilson/dir. Isaac Lamb", where: "Third Rail Repertory Theatre" },
      { what: "The Marriage of Figaro", who: "Mozart/dir. Daniel Helfgot", where: "Aquilon Music Festival" },
      { what: "La Chûte de Phaëton+", who: "Legrand/dir. Daniel Helfgot", where: "Aquilon Music Festival" },
    ],
    "Workshops / Readings": [
      { what: "In Case of Bruising", who: "Kamila Boga", where: "Ashland New Plays Festival" },
      { what: "Strange Birds", who: "E.M. Lewis", where: "Fishtrap Theater" },
      { what: "Sapience", who: "Diana Burbano", where: "Artists Repertory Theatre" },
      { what: "Pygmalion: A Tall Tale", who: "Keelay Gipson", where: "Artists Repertory Theatre" },
    ],
    Honors: [
      { what: "SDC Foundation", who: "Directing Fellow / Young Americans", where: "" },
      { what: "Speakeasy Stage Company", who: "Thomas Derrah Emerging Artist Award / English", where: "" },
      { what: "Lime Arts / 20x20 Fringe", who: "Excellence in Technical Achievement Award / Abundancia", where: "" },
      { what: "Opera America", who: "Robert L.B. Tobin Director-Designer Prize / Orfeo ed Euridice", where: "" },
      { what: "MusaMadre Sardinia", who: "One year for freedom of writing residency curated by Nassim Soleimanpour", where: "" },
      { what: "Grow Grant", who: "Fertile Ground Festival of New Works", where: "" },
      { what: "PICA Precipice Fund Grant", who: "Through the Looking Glass Artist Residency Program Curator", where: "" },
      { what: "Ford Family Foundation Grant", who: "Blooms SWANA Artist Solo Show Curator", where: "" },
    ],
    "Regional Staff / Associations": [
      { what: "Stage Directors & Choreographers Society", who: "Associate Member", where: "" },
      { what: "Artists Repertory Theatre / Portland, OR", who: "Artistic & Producing Associate / PATHWAYS Founder/Co-Facilitator", where: "" },
      { what: "Bag&Baggage Productions / Hillsboro, OR", who: "Resident Artist Company Member", where: "" },
      { what: "Huntington Theatre Company / Boston, MA", who: "Literary Apprentice / Huntington Playwriting Fellows Co-Facilitator", where: "" },
      { what: "American Conservatory Theater / San Francisco, CA", who: "Young Conservatory Intern", where: "" },
    ],
  };

  const otherRows = {
    Dramaturgy: [
      { what: "Layalina", who: "Yousif Zebari", where: "National Queer Theatre" },
      { what: "<<when we write with ashes>>+", who: "Victor I. Cazares", where: "National Queer Theatre" },
      { what: "Middletown Mall+", who: "Lava Alapai", where: "Third Rail Repertory Theatre" },
      { what: "True Story", who: "E.M. Lewis", where: "Artists Repertory Theatre" },
      { what: "the ripple, the wave that carried me home", who: "Cristina Anderson", where: "Portland Center Stage" },
      { what: "Our Utopia+", who: "Carlos-Zenen Trujillo", where: "Bag&Baggage Productions" },
    ],
    Producing: [
      { what: "The Storyteller+", who: "Sara Jean Accuardi", where: "Artists Repertory Theatre" },
      { what: "The Bed Trick", who: "Keiko Green", where: "Artists Repertory Theatre" },
    ],
    "Visual Art Curation": [
      { what: "Through the Looking Glass", who: "Artist Residency Program", where: "SWANA Rose Culture + Community Center" },
      { what: "Blooms", who: "Solo Show Series", where: "SWANA Rose Culture + Community Center" },
    ],
  };

  return (
    <>
    <Featured items={features} />
    <div className="w-full px-4 md:px-8 py-8">
      <h1
        className="text-3xl md:text-4xl font-bold tracking-tight mb-6 select-none"
        style={{ color: MAROON }}
      >
        Directing Credits:
      </h1>
      <Section labels={directingLabels} rowsMap={directingRows} />

      <h1
        className="text-3xl md:text-4xl font-bold tracking-tight mt-8 mb-6 select-none"
        style={{ color: MAROON }}
      >
        Other Works:
      </h1>
      <Section labels={otherLabels} rowsMap={otherRows} />

      <KeyBlock />
    </div>
    </>
  );
}

